 //Quick View

 
$(document).ready(function () {
  $.getScript("//cdnjs.cloudflare.com/ajax/libs/fancybox/2.1.5/jquery.fancybox.min.js").done(function() {
    quickView();
  });
});

function quickView() {
  $(".quick-view").click(function () {
    if ($('#quick-view').length == 0){$("body").append('<div id="quick-view"></div>');}
    var product_handle = $(this).data('handle');
    var data_subtitle = $(this).data('subtitle');
    var data_pack = $(this).data('pack');
    var data_badge = $(this).data('badge');
    var data_promotion = $(this).data('promotion');
    $('#quick-view').addClass(product_handle);
    jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
 
      // inject reCharge Widget
      const config = {
        productId: product.id, // Required
        injectionParent: '.qv-add-to-cart', // The node that will have the widget injected in
        injectionMethod: 'prepend', // How will the widget be injected 
        injectFn: (node, target) => {}, // Runs a custom injection function 
        selectors: {
          price: ['.pricePopup'], // the selectors that will be updated based on subscription
          variant: ['.qv-product-options'] // The variants to watch for to update the subscription prices
        }
      };
      window.ReChargeWidget.createWidget(config);
      // end inject reCharge Widget
      
      // inject stamped widget product.id
        $('.stamped-product-reviews-badge').attr('data-id', product.id);
        StampedFn.reloadUGC();  
      // end stamped widget

      var id = product.id
      $('#quick-view').attr("data-product-id", id);
      $('#quick-view').attr("data-section-id", id);
     
      var title = product.title;
      var type = product.type;
      var price = 0;
      var original_price = 0;
      var desc = product.description;
      var images = product.images;
      let variants = product.variants;
      var options = product.options;
      var url = '/products/' + product_handle;
      
      console.log('')
      $('.product-single__title').text(title);
      $('.product-single__subtitle').text(data_subtitle);
      $('.product-single__info').text(data_pack);
      $('.product-single__promo').text(data_promotion);  
      
     // $('.qv-product-description').html(desc);
      $('.view-product-details').attr('href', url);
      var imageCount = $(images).length;
      $(images).each(function (i, image) {
        if (i == imageCount - 1) {
          var image_embed = '<div><img class="lazy2" src="' + image + '"></div>';
          image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');
          $('.qv-product-images').append(image_embed);
          $('.qv-product-images').slick({
            'dots': false,
            'arrows': true,
            'respondTo': 'min',
            'useTransform': false
          }).css('opacity', '1');
        } else {
          image_embed = '<div><img class="lazy2" src="' + image + '"></div>';
          image_embed = image_embed.replace('.jpg', '_800x.jpg').replace('.png', '_800x.png');
          $('.qv-product-images').append(image_embed);
        }
      });
      function containsSpecialChars(str) {
        const specialChars = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
        return specialChars.test(str);
      }
      $(options).each(function (j, option) {
        var opt = option.name;
        var opt2 = opt.replaceAll(' ','-')
        var opt3 = opt2.replace("'('",'')
        var opt4 = opt3.replace("')'",'')
        var selectClass = '.option.' + opt4.toLowerCase();
        if(containsSpecialChars(opt4)){
          opt4 = opt4.substr(0, opt4.indexOf('-')); 
        }
        $('.qv-product-options').append('<div class="vrnts option-selection-' + opt4.toLowerCase() + '"><span class="optionn">' + opt + '</span><div class="variant-input-wrap tt option-' + j + ' option ' + opt4.toLowerCase() + '"></div ></div>');
        let checkedOne = checkFirstVariantAvailable()
        
        $(option.values).each(function (i, value) {

          $('.option.' + opt4.toLowerCase()).append('<div class="variant-input option-'+i+'"><input id="ProductSelect-'+value+'" type="radio" data-variant-input class="modalrdbtns" name="selectedopt-' + j +'" value="' + value + '"> <label for="ProductSelect-'+value+'" value="' + value + '" class="lblmodal">'+value+'</label></div>');
        
           /*$('.modalrdbtns').attr('checked','checked')
            
            var indexfrst = product.variants[i].featured_image.position - 1;

              $('.slick-initialized').slick('slickGoTo', indexfrst);*/
        });
        if(checkedOne != undefined){
          let ProductChecked = document.querySelectorAll('.modalrdbtns');
           ProductChecked.forEach(item =>{
             if(checkedOne.title.includes('/')){
               let wordsArr = checkedOne.title.split(' / ');
               wordsArr.forEach(cmpndWord =>{
                 if(cmpndWord.trim() == item.value){
                   item.checked = true;
                    product.variants.forEach(variantitm =>{
                    if(variantitm.title.includes(item.value)){
                        checkAvailability(variantitm)
                        var indexfrst = variantitm.featured_image.position - 1;
                        $('.slick-initialized').slick('slickGoTo', indexfrst);
                    }
                })
                 }
               })
             }else{
              if(checkedOne.title.includes(item.value)){
                item.checked = true;
                 product.variants.forEach(variantitm =>{
                    if(variantitm.title.includes(item.value)){
                        checkAvailability(variantitm)
                      if(variantitm.featured_image != null){
                        var indexfrst = variantitm.featured_image.position - 1;
                        $('.slick-initialized').slick('slickGoTo', indexfrst);
                      }
                    }
                })
              
              }
           }
            
           })
        }else{
          let title = document.querySelector('.product-single__title').textContent
          if(product.title === title){
            price = parseFloat(product.price / 100).toFixed(2);
            original_price = parseFloat(product.compare_at_price / 100).toFixed(2);
            $('.pricePopup').text('$' + price);
            $('.qv-add-button').prop('disabled', true).val('Out of Stock');
            $('.qv-add-to-cart').hide();
            $('.product-single__prices').addClass('noStock').text('Out of Stock').show();
            $('.vrnts').hide();
           }
        }
      });
      /*$(product.variants).each(function (i, v) {

        if (v.inventory_quantity == 0 || !v.available) {
          $('.qv-add-button').prop('disabled', true).val('Out of Stock');
          $('.qv-add-to-cart').hide();
          $('.product-single__prices').addClass('noStock').text('Out of Stock').show();
           price = parseFloat(v.price / 100).toFixed(2);
          original_price = parseFloat(v.compare_at_price / 100).toFixed(2);
          $('.pricePopup').addClass('priceOutStock').text('$' + price);
          if (original_price > 0) {
            $('.qv-product-original-price').text('$' + original_price).show();
          } else {
            $('.qv-product-original-price').hide();
          }
          $('select.option-0').val(v.option1);
          $('select.option-1').val(v.option2);
          $('select.option-2').val(v.option3);
          return true
        } else {
         
          $('.qv-add-button').prop('disabled', false).val('Add to Cart');
          $('.qv-add-to-cart').show();
          $('.product-single__prices').removeClass('noStock').text('');
          $('.pricePopup').removeClass('priceOutStock');
        
          price = parseFloat(v.price / 100).toFixed(2);
          original_price = parseFloat(v.compare_at_price / 100).toFixed(2);
          $('.pricePopup').text('$' + price);
          if (original_price > 0) {
            $('.qv-product-original-price').text('$' + original_price).show();
          } else {
            $('.qv-product-original-price').hide();
          }
          $('select.option-0').val(v.option1);
          $('select.option-1').val(v.option2);
          $('select.option-2').val(v.option3);
          return false
        }
      });*/
        function checkFirstVariantAvailable(){
       
          let prod = product.variants.find(product =>{
           if( product.available){
            return product
           }
        })
       return prod
      
    }
           var selectedOptions = '';
      $("#quick-view div.tt").off()
    const quickInputs = $("#quick-view div.tt")
          
      quickInputs.off()
      quickInputs.on("change", function () {
      
     
      $('#quick-view div.tt').each(function (i, item) {
        var found =false;
        if (selectedOptions == '') {
  
          selectedOptions = $(item).find('input:checked').val();
           product.variants.forEach(itm =>{
            if(itm.title === selectedOptions){
              found = true;
              console.log(itm.featured_image.src);
              
              let newimg = document.querySelector('.slick-current');
              var imgindex = itm.featured_image.position - 1;

              $('.slick-initialized').slick('slickGoTo', imgindex);
              checkAvailability(itm)
              
            }else{
              found = false
             
              let titleSlice = itm.title.split(' / ');
               titleSlice.forEach(item =>{
                if(item.trim() === selectedOptions){
                  var imgindex = itm.featured_image.position - 1;
                  $('.slick-initialized').slick('slickGoTo', imgindex);
                }
              })
              

              
            }
             
          })
          
          
           
        } else {
          let nmbrVrnts = document.querySelectorAll('.vrnts');

          if(nmbrVrnts.length > 1){
            selectedOptions = selectedOptions + ' / ' + $(item).find('input:checked').val();
          }else{
            selectedOptions = $(item).find('input:checked').val();
          }
 
           variants.forEach(itm =>{
            if(itm.title == selectedOptions){
              found = true;
              console.log(itm.featured_image.src);
              
              let newimg = document.querySelector('.slick-current');
              var imgindex = itm.featured_image.position - 1;

              $('.slick-initialized').slick('slickGoTo', imgindex);
              checkAvailability(itm)
               selectedOptions ="" 
            }

          })
          if(found == false){
            
               selectedOptions ="" 
          $('.qv-add-button').prop('disabled', true).val('Out of Stock');
          $('.qv-add-to-cart').hide();
          $('.product-single__prices').addClass('noStock').text('Out of Stock').show();
           
          }
        }


      });
      });    
      
      
        $(product.variants).each(function (i, v) {
          if (v.title == selectedOptions) {
            var price = parseFloat(v.price / 100).toFixed(2);
            var original_price = parseFloat(v.compare_at_price / 100).toFixed(2);
            var v_qty = v.inventory_quantity;
           let variants = product.variants;
            var v_inv = v.inventory_management;
            $('.pricePopup').text('$' + price);
            $('.qv-product-original-price').text('$' + original_price);
            if (v_inv == null) {
              $('.qv-add-button').prop('disabled', false).val('Add to Cart');
            } else {
              if (v.inventory_quantity < 1 || !v.available ) {
                $('.qv-add-button').prop('disabled', true).val('Out of Stock');
              } else {
                $('.qv-add-button').prop('disabled', false).val('Add to Cart');
              }
            }
          }
        });
    });
  
    function checkAvailability(variant){
          if (variant.inventory_quantity == 0 || !variant.available) {
          $('.qv-add-button').prop('disabled', true).val('Out of Stock');
          $('.qv-add-to-cart').hide();
          $('.product-single__prices').addClass('noStock').text('Out of Stock').show();
           price = parseFloat(variant.price / 100).toFixed(2);
          original_price = parseFloat(variant.compare_at_price / 100).toFixed(2);
          $('.pricePopup').addClass('priceOutStock').text('$' + price);
          if (original_price > 0) {
            $('.qv-product-original-price').text('$' + original_price).show();
          } else {
            $('.qv-product-original-price').hide();
          }
          $('select.option-0').val(variant.option1);
          $('select.option-1').val(variant.option2);
          $('select.option-2').val(variant.option3);
          return true
        } else {
         
          $('.qv-add-button').prop('disabled', false).val('Add to Cart');
          $('.qv-add-to-cart').show();
          $('.product-single__prices').removeClass('noStock').text('');
          $('.pricePopup').removeClass('priceOutStock');
        
          price = parseFloat(variant.price / 100).toFixed(2);
          original_price = parseFloat(variant.compare_at_price / 100).toFixed(2);
          $('.pricePopup').text('$' + price);
          if (original_price > 0) {
            $('.qv-product-original-price').text('$' + original_price).show();
          } else {
            $('.qv-product-original-price').hide();
          }
          $('select.option-0').val(variant.option1);
          $('select.option-1').val(variant.option2);
          $('select.option-2').val(variant.option3);
          return false
        }

      
    }
    $.fancybox({
      href: '#quick-view',
      maxWidth: 1040,
      maxHeight: 600,
      fitToView: true,
      width: '75%',
      height: '70%',
      autoSize: false,
      closeClick: false,
      openEffect: 'none',
      closeEffect: 'none',
      'beforeLoad': function () {
        var product_handle = $('#quick-view').attr('class');
        $(document).on("click", ".qv-add-button", function () {
          var qty = $('.qv-quantity').val();
          var selectedOptions = '';
          var var_id = '';
          const recharge_plan_id = $('.rc_widget__option__plans__dropdown option:selected').val();
          $('#quick-view div.tt').each(function (i, item) {
               if (selectedOptions == '') {
  
          selectedOptions = $(item).find('input:checked').val();
         
           
        } else {
          selectedOptions = selectedOptions + ' / ' + $(item).find('input:checked').val();
        
        }
          });
      
          jQuery.getJSON('/products/' + product_handle + '.js', function (product) {
            $(product.variants).each(function (i, v) {
              if (v.title == selectedOptions) {
                var_id = v.id;
                selling_plan = recharge_plan_id;
                processCart();
              }
            });
          });
          function processCart() {
            jQuery.post('/cart/add.js', {
              quantity: qty,
              id: var_id,
              selling_plan: recharge_plan_id
            },
                        null,
                        "json"
                       ).done(function () {
              $('.qv-add-to-cart-response').addClass('success').html('<span">' + $('.qv-product-title').text() + ' has been added to your cart. <a class="modalAdd" href="/cart">Click here to view your cart.</a></span>');
              $('.qv-add-button').css('background-color', 'red');
              location.reload(true)
            })
            .fail(function ($xhr) {
              var data = $xhr.responseJSON;
              $('.qv-add-to-cart-response').addClass('error').html('<span><b>ERROR: </b>' + data.description);
            });
          }
        });
        $('.fancybox-wrap').css('overflow', 'hidden !important');
        
      },
      'afterShow': function () {
        $('#quick-view').hide().html(content).css('opacity', '1').fadeIn(function () {
          $('.qv-product-images').addClass('loaded');
          
        });
      },
      'afterClose': function () {
        $('#quick-view').removeClass().empty();
        
      }
    });
  });
};

 
$(window).resize(function () {
  if ($('#quick-view').is(':visible')) {
    $('.qv-product-images').slick('setPosition');
  }
});